let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ktWxg")).then(() => parcelRequire('cV5t9'));